export default function isProduction() {
	const appUrl = new URL(location.href).origin;

	return !appUrl.includes('test') && !appUrl.includes('localhost');
}